import queryString from 'query-string'
import { configs } from "./config"
import { gima } from 'gima-common'
const params = queryString.parse(window.location.search)
const queryApplicationCode = params["ApplicationCode"]
const queryshowSend = params["showSend"]
const queryshowmassMail = params["MassMailing"]
const queryshowEDM = params["EDM"]
const queryshowAdmin = params["admin"]
const queryShowEmailCollection = params["emailCollection"]

const Setting = {
  validCompanyCodes: ["irmsdev2", "siiademo", "silkrelo", "interrelo", "rugimus", "packimpex"],
  cred: {
    // CompanyCode: 'Innoways',
    CompanyCode: gima.getTokenInfo('company_code') || "siia",
    StaffCode: gima.getTokenInfo('username') || "null",
    StaffEmail: sessionStorage.getItem('staffEmail'),
    Type: sessionStorage.getItem('Type') || "Personal",
    OwnerCode: sessionStorage.getItem('Owner') || ""
  },
  showSend: queryshowSend ? Boolean(queryshowSend === "true") : Boolean(localStorage.getItem("showSend") === "true") || false,
  isMassMail: queryshowmassMail ? Boolean(queryshowmassMail === "true") : Boolean(localStorage.getItem("MassMailing") === "true") || false,
  isEDM: queryshowEDM ? Boolean(queryshowEDM === "true") : Boolean(localStorage.getItem("EDM") === "true") || false,
  isAdmin: queryshowAdmin ? Boolean(queryshowAdmin === "true") : Boolean(localStorage.getItem("admin") === "true") || false,
  isEmailCollection: queryShowEmailCollection ? Boolean(queryShowEmailCollection === "true") : Boolean(localStorage.getItem("emailCollection") === "true") || false,
  isBusinessMail: queryApplicationCode ? Boolean(queryApplicationCode !== "GIMA") : Boolean(localStorage.getItem("ApplicationCode") !== "GIMA") || false,
  apiUrl: configs.apiUrl,
  dmsApiURL: configs.dmsApiURL,
  apiFileUrl: configs.apiFileUrl,
  baseUrl: configs.baseUrl,
  dmsURL: configs.dmsURL,
  dmsDownloadAPI: configs.dmsDownloadAPI,
  mailMergeApi: configs.mailMergeApi,
  mailServerAPI: configs.mailServerAPI,
  pageSize: 20,
  token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55Q29kZSI6Iklubm93YXlzIiwic3RhZmZDb2RlIjoiWXUuQ2hlbiIsImV4cCI6MTY3MTUwNDc3NCwiaWF0IjoxNjM5OTY4Nzc0fQ.BMz4EuTaBTvWAzqC8IFcO3uq67h8UL1Y2NGC2M6TS58',
  applicationListAPI: configs.applicationListAPI, //`https://sso-api-uat.gima.app/api/v3/Application/${JSON.parse(localStorage.getItem('userData'))?.company_code}`,
  applicationListPrdAPI: configs.applicationListPrdAPI,
  applicationListUATAPI: configs.applicationListUATAPI,
  gimaBasePersonal: configs.gimaBasePersonal,
  gimaAPI: configs.gimaAPI,
  membershipAPI: configs.memberShipApi,
  appListAPI: {
    dev: configs.applicationListAPI,
    uat: configs.applicationListUATAPI,
    prd: configs.applicationListPrdAPI,
    demo: configs.applicationListDemoAPI,
    dr: configs.applicationListDrAPI
  }
}
export default Setting